<template>
    <div class="activation-container">
      <div class="activation-wrapper">
        
        <!-- Top Primary Activation Status Card -->
        <header class="status-card">
          <div class="status-top-row">
            <div class="type-badge">
              <span class="badge-label">ACTIVATION TYPE</span>
              <h1 class="badge-title">Harmonized Rent</h1>
            </div>
            <!-- Shield Vector Outline Icon -->
            <div class="shield-icon-wrapper">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
            </div>
          </div>
  
          <div class="divider-line"></div>
  
          <!-- Meta Metrics Meta Grid Info -->
          <div class="status-meta-grid">
            <div class="meta-item">
              <span class="selected-label">Selected Property</span>
              <p class="selected-value">{{ receivedSelections.totalPropertiesSelected }}<span class="title-subtext">({{ receivedSelections.totalUnitsSelected }} units)</span></p>
              <h5 class="total-amount">&#x20A6;{{totalPropertiesPrice}}/yr</h5>
            </div>
            <div class="meta-item text-right">
              <span class="selected-label">Rent Payment Date</span>
              <p class="selected-value">{{ receivedSelections.harmonizeDate | moment }} <span class="title-subtext">(Yearly)</span></p>
            </div>
          </div>
        </header>
  
        <!-- Bottom Explainer Card Surface Block -->
        <main class="info-card">
          <h2 class="info-headline">What this means</h2>
  
          <!-- Feature Entry Item Row 1 -->
          <div class="explainer-row">
            <div class="icon-indicator blue-theme">
              <!-- Calendar with Checkmark Icon -->
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                <line x1="16" y1="2" x2="16" y2="6"/>
                <line x1="8" y1="2" x2="8" y2="6"/>
                <line x1="3" y1="10" x2="21" y2="10"/>
                <polyline points="9 16 11 18 15 13"/>
              </svg>
            </div>
            <div class="explainer-text">
              <h3 class="explainer-title">One single payout date</h3>
              <p class="explainer-desc">All rental income will be consolidated and disbursed on the 5th.</p>
            </div>
          </div>
  
          <!-- Feature Entry Item Row 2 -->
          <div class="explainer-row">
            <div class="icon-indicator blue-theme">
              <!-- Safe Transfer Wallet Layout Icon -->
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2"/>
                <circle cx="12" cy="12" r="2"/>
                <path d="M12 7v3M12 14v3M7 12h3M14 12h3"/>
              </svg>
            </div>
            <div class="explainer-text">
              <h3 class="explainer-title">Automatic Transfer to SAFE</h3>
              <p class="explainer-desc">Funds are secured immediately upon collection in your SAFE.</p>
            </div>
          </div>
        </main>

        <div class="button-holder">
          <button class="btn main" @click="activateHarmonizeRent()" :disabled="loading">
            {{ loading ? 'Processing' : 'Activate Now' }}
            <i
                class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                v-if="loading"
                >
            </i>
          </button>
          <button class="btn cancel" @click="goBack()">Cancel</button>
        </div>
  
      </div>
    </div>
  </template>
  
  <script>
  import { Service } from "../../store/service";
  const Api = new Service();
  import moment from "moment";
  export default {
    name: 'HarmonizedSummary',
    data() {
      return {
        loading: false,
        receivedSelections: {
          selectedUnits: [],
          totalPropertiesSelected: 0,
          totalUnitsSelected: 0
        },
      };
    },
    computed: {
      totalPropertiesPrice() {
        // 1. Fallback to empty array if data isn't loaded yet
        const units = this.receivedSelections?.selectedUnits || [];
        
        // 2. Loop and accumulate the values
        const total = units.reduce((accumulator, unit) => {
          // Safely grab the price, remove commas, and convert to an integer/float
          const cleanPrice = String(unit.unitPrice || 0).replace(/,/g, '');
          const priceAsNumber = parseFloat(cleanPrice) || 0;
          
          return accumulator + priceAsNumber;
        }, 0);

        // 3. Format it back to a readable string with commas for your UI
        return total.toLocaleString('en-US');
      }
    },
    beforeRouteEnter(to, from, next) {
      const hasSavedData = sessionStorage.getItem('unitSelections');

      if (!hasSavedData) { 
        // If 'from.path' is just the root '/' or empty, fallback to the selector route
        const fallbackPath = from.path !== '/' ? from.path : '/dashboard/rent-list';
        
        // Kick them back to where they came from
        next(fallbackPath);
      } else {
        // Data exists, allow the page to open normally
        next();
      }
    },
    created() {
      const savedUnitData = sessionStorage.getItem('unitSelections');
      if (savedUnitData) {
      this.receivedSelections = JSON.parse(savedUnitData);
      // console.log('Selected UNITS:', this.receivedSelections);
    }
      // EventBus.$on('update-selection-summary', this.updateLocalData);
    },
    
    methods: {
      goBack() {
        this.$router.go(-1)
      },
      async activateHarmonizeRent() {
        this.loading = true;
        try {
            const payload = this.receivedSelections.selectedUnits.map(item => item.property_id);
            const formData = new FormData();
            formData.append('properties', JSON.stringify(payload));
            formData.append('date', JSON.stringify(this.receivedSelections.harmonizeDate));
            await Api.postRequest(`apply-for-harmonised-rent-request`, formData).then(res => {
                // console.log("Response on application", res)
                this.loading = false;
                if (res.data.success) {
                  this.$router.push("gharmonized-rent-home");
                  return this.$store.commit("setApiSuccess", "Application sent pending verifications");
                }
                if (res.data.error) {
                  return this.$store.commit("setApiFailed", res.data.error);
                }
            }).catch(err => {
              this.loading = false;
              console.log("err:", err)
            })
          } finally {
            this.loading = false;
            // console.log("Closed")
          }
      },
    },
    filters: {
      moment: function(date) {
        console.log("dataaaa", date)
        return moment(date).format("MMMM Do");
      }
      // moment: function(date) {
      //   return moment(date).format("MMMM DD YYYY, h:mm:ss a");
      // },
    },
  immediate: true
  };
  </script>


<style scoped lang="scss">

// Theme Tokens
$bg-canvas: #f8faff;
$surface-white: #ffffff;
$gradient-blue-start: #0062ff;
$gradient-blue-end: #0045eb;
$text-light: #ffffff;
$text-dark: #0f1422;
$text-muted: #5b6479;
$brand-blue: #0042e6;
$border-color: rgba(255, 255, 255, 0.15);

// Structural Layout Frame Framework
.activation-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  
  background-color: $bg-canvas;
  padding: 1.25rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
}

// Wrapper Module Frame 
.activation-wrapper {
  width: 100%;
  max-width: 440px;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  box-shadow: 
      0 0 0 1px rgba(0, 0, 0, 0.05), 
      0 4px 12px rgba(0, 0, 0, 0.05), 
      0 12px 24px rgba(0, 0, 0, 0.05);
  padding: 15px;
  border-radius: 12px;
}

// Upper Gradient Accent Container Layout Block
.status-card {
  background: linear-gradient(135deg, $gradient-blue-start 0%, $gradient-blue-end 100%);
  color: $text-light;
  border-radius: 24px;
  padding: 2.2rem 1.8rem;
  box-shadow: 0 12px 30px rgba(0, 70, 235, 0.18);
  width: 100%;
  display: flex;
  flex-direction: column;

  .status-top-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1rem;
    margin-bottom: 1.8rem;

    .type-badge {
      display: flex;
      flex-direction: column;
      gap: 0.45rem;

      .badge-label {
        font-size: 0.78rem;
        font-weight: 700;
        letter-spacing: 0.8px;
        opacity: 0.85;
        text-align: left;
        font-family: Lato;
      }

      .badge-title {
        font-size: 1.7rem;
        font-weight: 700;
        letter-spacing: -0.3px;
        line-height: 1.2;
        text-align: left;
        font-family: Lato;
      }
    }

    .shield-icon-wrapper {
      width: 28px;
      height: 28px;
      opacity: 0.85;
      flex-shrink: 0;
      margin-top: 2px;

      svg {
        width: 100%;
        height: 100%;
      }
    }
  }

  .divider-line {
    height: 1px;
    background-color: $border-color;
    width: 100%;
    margin-bottom: 1.6rem;
  }

  // Row Column Flex Grid Meta Config
  .status-meta-grid {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1rem;

    .meta-item {
      display: flex;
      flex-direction: column;
      gap: 0.4rem;
      flex: 1;

      &.text-right {
        text-align: right;
      }

      .selected-label {
        font-size: 0.85rem;
        opacity: 0.75;
        font-weight: 400;
        text-align: left;
        font-family: Lato;
      }

      .selected-value {
        font-size: 1.35rem;
        font-weight: 700;
        letter-spacing: -0.1px;
        line-height: 1.2;
        text-align: left;
        font-family: Lato;

        .title-subtext {
          font-weight: 400;
          font-size: 0.98rem;
          opacity: 0.8;
          font-family: Lato;
        }
      }
    }
  }
}

.total-amount {
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.2;
  text-align: left;
  font-family: Lato;
}

// White Summary Card Details Block Frame
.info-card {
  background-color: $surface-white;
  border-radius: 24px;
  padding: 2.2rem 1.8rem;
  box-shadow: 0 10px 40px rgba(15, 20, 34, 0.02);
  display: flex;
  flex-direction: column;
  width: 100%;

  .info-headline {
    font-size: 1.35rem;
    font-weight: 700;
    color: $text-dark;
    letter-spacing: -0.2px;
    margin-bottom: 1.8rem;
    font-family: Lato;
    text-align: left;
  }

  // Segment Row Features Blocks
  .explainer-row {
    display: flex;
    align-items: flex-start;
    gap: 1.1rem;
    margin-bottom: 1.8rem;

    &:last-child {
      margin-bottom: 0;
    }

    .icon-indicator {
      width: 24px;
      height: 24px;
      margin-top: 3px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      &.blue-theme {
        color: $brand-blue;
      }

      svg {
        width: 100%;
        height: 100%;
      }
    }

    .explainer-text {
      display: flex;
      flex-direction: column;
      gap: 0.35rem;

      .explainer-title {
        font-size: 1.05rem;
        font-weight: 600;
        color: $text-dark;
        letter-spacing: -0.1px;
        text-align: left;
        font-family: Lato;
      }

      .explainer-desc {
        font-size: 0.94rem;
        color: $text-muted;
        line-height: 1.45;
        font-family: Lato;
        text-align: left;
      }
    }
  }
}

// Micro Screen Breakpoint Adaptations
@media (max-width: 375px) {
  .status-card {
    padding: 1.6rem 1.3rem;
    
    .status-top-row .type-badge .badge-title {
      font-size: 1.45rem;
    }
    
    .status-meta-grid .meta-item .selected-value {
      font-size: 1.15rem;
      
      .title-subtext {
        font-size: 0.88rem;
      }
    }
  }

  .info-card {
    padding: 1.6rem 1.3rem;
    
    .info-headline {
      font-size: 1.2rem;
      margin-bottom: 1.4rem;
    }
    
    .explainer-row {
      gap: 0.85rem;
      margin-bottom: 1.4rem;
      
      .explainer-text {
        .explainer-title {
          font-size: 0.98rem;
        }
        .explainer-desc {
          font-size: 0.88rem;
        }
      }
    }
  }
}
.button-holder {
    margin-top: 30px;
    margin-bottom: 20px;
    width: 100%;
    button {
      width: 100%;
      height: 50px;
      font-family: Lato;
      box-shadow: none;
      outline: 0;
    }
    .main {
      background-color: #0033EA;
      color: #ffffff;
      margin-bottom: 15px;
    }
    .cancel {
      background-color: #E6F0FA;
      color: #0033EA;
    }
}
</style>
  